import React from 'react';
import Icon from '@/components/ui/AppIcon';

const kpis = [
  {
    id: 'akpi-total', label: 'Total créateurs', value: '247', sub: '+12 ce mois',
    trend: 'up', icon: 'UsersIcon', color: 'text-primary bg-primary/10 border-primary/20',
  },
  {
    id: 'akpi-verified', label: 'Créateurs vérifiés', value: '189', sub: '76.5% du total',
    trend: 'up', icon: 'ShieldCheckIcon', color: 'text-positive bg-positive/10 border-positive/20',
  },
  {
    id: 'akpi-pending', label: 'En attente review', value: '7', sub: '3 en attente > 48h',
    trend: 'down', icon: 'ClockIcon', color: 'text-warning bg-warning/10 border-warning/20',
  },
  {
    id: 'akpi-brands', label: 'Comptes marques', value: '34', sub: '8 actifs ce mois',
    trend: 'up', icon: 'BuildingOffice2Icon', color: 'text-info bg-info/10 border-info/20',
  },
  {
    id: 'akpi-campaigns', label: 'Campagnes ce mois', value: '11', sub: '3 en cours · 8 terminées',
    trend: 'neutral', icon: 'RocketLaunchIcon', color: 'text-accent bg-accent/10 border-accent/20',
  },
  {
    id: 'akpi-momentum', label: 'Momentum Score moyen', value: '74.2', sub: '+2.4 vs mois préc.',
    trend: 'up', icon: 'BoltIcon', color: 'text-positive bg-positive/10 border-positive/20',
  },
];

export default function AdminKPIs() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {kpis.map((kpi) => (
        <div key={kpi.id} className={`bg-card border rounded-xl p-4 ${kpi.color.split(' ').slice(1).join(' ')}`}>
          <div className="flex items-center justify-between mb-2">
            <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${kpi.color.split(' ').slice(0, 2).join(' ')}`}>
              <Icon name={kpi.icon as Parameters<typeof Icon>[0]['name']} size={14} />
            </div>
          </div>
          <p className="text-xl font-800 text-foreground font-mono">{kpi.value}</p>
          <p className="text-xs font-600 text-foreground mt-0.5">{kpi.label}</p>
          <p className={`text-xs mt-1 ${kpi.trend === 'up' ? 'text-positive' : kpi.trend === 'down' ? 'text-warning' : 'text-muted-foreground'}`}>
            {kpi.trend === 'up' && '↑ '}{kpi.trend === 'down' && '⚠ '}{kpi.sub}
          </p>
        </div>
      ))}
    </div>
  );
}